(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mayhem-canada-badge"] && !Shopify.designMode) return;
  try {
    (() => {
  const update = () => {
    document.querySelectorAll('[data-mayhem-canada="product"]').forEach(badge => {
      let rows;
      try { rows = JSON.parse(badge.querySelector('[data-canada-variants]').textContent); } catch { badge.hidden = true; return; }
      const selected = document.querySelector('[data-mayhem-specs]')?.dataset.selectedVariantId;
      const eligible = selected ? rows.filter(row => row.id === String(selected)) : rows;
      badge.hidden = !eligible.length || !eligible.every(row => row.only === true);
    });
  };
  document.addEventListener('mayhem:spec-selection-changed', update);
  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mayhem-spec-help"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.mayhem-spec-guide').forEach((guide, index) => {
    const topics = [...guide.querySelectorAll('.mayhem-spec-guide__topic')];
    const mobile = matchMedia('(max-width:749px)');
    const arrange = () => {
      topics.forEach(topic => {
        topic.removeAttribute('name');
        topic.open = !mobile.matches;
      });
      if (mobile.matches) topics.forEach(topic => topic.setAttribute('name', `mayhem-spec-topic-${index}`));
    };
    arrange();
    mobile.addEventListener('change', arrange);
    topics.forEach(topic => topic.addEventListener('toggle', () => {
      if (mobile.matches && topic.open) topics.forEach(other => { if (other !== topic) other.open = false; });
    }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mayhem-wheel-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-mayhem-card-fitment]';
    const pending = new Map();
    const active = new Map();
    const vehicleData = new Map();
    const wheelData = new Map();
    const wheelQueue = [];
    let wheelRequests = 0;
    let nextWheelRequestAt = 0;
    let wheelStartTimer = 0;
    const collectionGrids = new Map();
    let generation = 0;
    let running = 0;
    const queue = [];
    const limit = 12;
    let fitmentOnly = location.pathname.startsWith('/collections/') &&
      new URL(location.href).searchParams.get('fitment') === 'matches';
    const requestedPages = new Set();
    let resultsStatus;
    let loadingPlaceholder;
    let checkFailed = false;
    let pageLoadFailed = false;
    let settleFrame = 0;
    let fitmentReady = false;
    let loadingSince = 0;
    const num = value => value == null || value === '' ? NaN : Number(value);
    let eventVehicleId;

    const selectedId = () => {
      const native = window.TWGFitmentPreview?.selectedVehicle();
      return native ? 'fg:' + Object.values(native.query).join(':') : '';
    };
    const getJson = async (path, params) => {
      const url = new URL('https://api.autosyncstudio.com' + path);
      url.searchParams.set('key', 'mayhem');
      for (const [name, value] of Object.entries(params)) url.searchParams.set(name, value);
      for (let attempt = 0; attempt < 3; attempt++) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 8000);
        let retryDelay = 300 * (2 ** attempt);
        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) {
            if (response.status >= 400 && response.status < 500 && ![408, 429].includes(response.status)) {
              throw Object.assign(new Error('AutoSync rejected the request'), { permanent: true });
            }
            if (response.status === 429) {
              const wait = (await response.text()).match(/try again in\s+(\d+)ms/i);
              if (wait) retryDelay = Math.min(Number(wait[1]) + 150, 5000);
            }
            const after = Number(response.headers.get('Retry-After'));
            if (Number.isFinite(after) && after > 0) retryDelay = Math.max(retryDelay, Math.min(after * 1000, 5000));
            throw new Error('AutoSync temporarily unavailable');
          }
          const data = await response.json();
          if (data.Error) throw new Error('AutoSync temporarily unavailable');
          return data;
        } catch (error) {
          if (error.permanent || attempt === 2) throw error;
        } finally {
          clearTimeout(timer);
        }
        await new Promise(resolve => setTimeout(resolve, retryDelay + Math.random() * 150));
      }
    };
    const pumpWheelRequests = () => {
      if (wheelStartTimer || wheelRequests >= 4 || !wheelQueue.length) return;
      const wait = Math.max(0, nextWheelRequestAt - Date.now());
      wheelStartTimer = setTimeout(() => {
        wheelStartTimer = 0;
        const batch = [];
        let length = 0;
        while (wheelQueue.length && batch.length < 80) {
          const next = wheelQueue[0];
          if (batch.length && length + next.sku.length + 1 > 900) break;
          batch.push(wheelQueue.shift());
          length += next.sku.length + (batch.length > 1 ? 1 : 0);
        }
        if (!batch.length) return;
        wheelRequests++;
        nextWheelRequestAt = Date.now() + 110;
        getJson('/wheels', {
          'f-pns': batch.map(entry => entry.sku).join(','),
          'p-size': 500,
          'i-specs': 'true', 'i-img0300': 'true', 'i-img0100': 'true'
        }).then(data => {
          if (data.MoreItems) throw new Error('AutoSync returned an incomplete wheel batch');
          const bySku = new Map((data.Wheels || []).map(wheel => [String(wheel.Pn || '').toUpperCase(), wheel]));
          batch.forEach(entry => entry.resolve({ Wheels: [bySku.get(entry.sku.toUpperCase())].filter(Boolean) }));
        }).catch(error => batch.forEach(entry => entry.reject(error)))
          .finally(() => { wheelRequests--; pumpWheelRequests(); });
        pumpWheelRequests();
      }, Math.max(wait, 20));
    };
    const wheelFor = sku => {
      const key = sku.toUpperCase();
      if (!wheelData.has(key)) {
        wheelData.set(key, new Promise((resolve, reject) => {
          wheelQueue.push({ sku, resolve, reject });
          pumpWheelRequests();
        }).catch(error => { wheelData.delete(key); throw error; }));
      }
      return wheelData.get(key);
    };
    const vehicleFor = id => {
      if (!vehicleData.has(id)) {
        vehicleData.set(id, getJson('/vehicles', {
          'f-id': id, 'i-fitments': 'true', 'i-optionalFitments': 'true', 'i-plusSizes': 'true'
        }).then(data => data.Vehicles?.find(row => String(row.Id) === id)).catch(error => {
          vehicleData.delete(id);
          throw error;
        }));
      }
      return vehicleData.get(id);
    };
    const evaluateFitment = (vehicle, wheel, selection = null) =>
      window.MayhemFitmentPolicy?.evaluate(vehicle, wheel, selection) ||
      { state: 'unknown', reasons: [window.MayhemFitmentPolicyCopy?.unavailable || 'Fitment data is temporarily unavailable. Please try again.'] };
    const check = (id, variant) => {
      if (window.TWGFitmentPreview?.selectedVehicle()) {
        return window.TWGFitmentPreview.evaluateSku(variant.sku)
          .then(result => ({...result, previewAvailable:false}))
          .catch(() => ({state:'error',reasons:['Fitment is temporarily unavailable. Please try again.']}));
      }
      const sku = variant.sku;
      const key = id + '|' + sku.toUpperCase();
      if (!pending.has(key)) {
        pending.set(key, Promise.all([
          vehicleFor(id),
          wheelFor(sku).catch(() => ({ Wheels: [] }))
        ]).then(([vehicle, data]) => {
          const preview = data.Wheels?.find(wheel => wheel.Pn?.toUpperCase() === sku.toUpperCase());
          return { ...evaluateFitment(vehicle, window.MayhemManufacturerFitment.wheel(variant, preview)), previewAvailable: window.MayhemManufacturerFitment.hasPreview(preview) };
        }).catch(() => {
          pending.delete(key);
          return { state: 'error', reasons: ['Fitment data is temporarily unavailable. Please try again.'] };
        }));
      }
      return pending.get(key);
    };
    const candidatesFor = badge => {
      try {
        return JSON.parse(badge.closest('[data-mayhem-wheel-card]')
          ?.querySelector('[data-mayhem-card-variants]')?.textContent || '[]');
      } catch { return []; }
    };
    const checkVariants = async (id, badge) => {
      try {
        const vehicle = window.TWGFitmentPreview?.selectedVehicle() ? {} : await vehicleFor(id);
        if (!vehicle) return { state: 'unknown' };
        const candidates = candidatesFor(badge);
        const outcomes = await Promise.all(candidates.map(variant => {
          const patterns = [...String(variant.bolt || '').matchAll(/(\d+)\s*[-xX]\s*(\d+(?:\.\d+)?)/g)];
          const knownVehicle = Number.isFinite(num(vehicle.LugCount)) && Number.isFinite(num(vehicle.BoltCircle));
          if (knownVehicle && patterns.length && !patterns.some(([, lug, circle]) =>
            Number(lug) === num(vehicle.LugCount) && Math.abs(Number(circle) - num(vehicle.BoltCircle)) < 0.2)) {
            return { state: 'nofit', reasons: ['The bolt pattern does not match this vehicle.'] };
          }
          return check(id, variant);
        }));
        const matches = candidates.flatMap((variant, index) =>
          ['fits', 'caution'].includes(outcomes[index].state)
            ? [{ ...variant, state: outcomes[index].state, reasons: outcomes[index].reasons, sourceLabel: outcomes[index].label, fitmentTypes: outcomes[index].fitmentTypes || [], applications: outcomes[index].applications || [], sourceNotes: [...(outcomes[index].accessoryNotes || []), ...(Array.isArray(outcomes[index].notes) ? outcomes[index].notes.filter(note => /fitment group|twg/i.test(String(note?.source || ''))) : [])], previewAvailable: outcomes[index].previewAvailable }] : []);
        const preferred = matches.find(variant => variant.state === 'fits') || matches[0];
        if (preferred) return { state: preferred.state, variant: preferred, reasons: preferred.reasons, sourceLabel: preferred.sourceLabel, matches };
        const unresolved = outcomes.findIndex(outcome => outcome.state === 'unknown' || outcome.state === 'error');
        const index = unresolved >= 0 ? unresolved : 0;
        return { state: outcomes[index]?.state || 'unknown', variant: candidates[index], reasons: outcomes[index]?.reasons || [], sourceLabel: outcomes[index]?.label, matches: [] };
      } catch { return { state: 'error' }; }
    };
    const labels = {
      fits: 'fits your vehicle',
      caution: 'needs fitment review',
      nofit: 'does not fit',
      unknown: 'unable to verify'
    };
    const collectionItem = badge => badge.closest('.product-grid__item');
    const registerCollectionItem = badge => {
      if (!location.pathname.startsWith('/collections/')) return;
      const item = collectionItem(badge);
      const grid = item?.closest('.product-grid');
      if (!grid) return;
      if (!collectionGrids.has(grid)) collectionGrids.set(grid, new Map());
      const entries = collectionGrids.get(grid);
      if (!entries.has(item)) entries.set(item, { index: entries.size, state: 'unknown' });
      if (fitmentOnly && selectedId()) item.hidden = true;
    };
    const updateResultsStatus = () => {
      if (!fitmentOnly) return;
      const grid = document.querySelector('#ResultsList .product-grid');
      if (!grid) return;
      // Selection changes and section replacements may remove the original status.
      if (!resultsStatus?.isConnected) {
        resultsStatus = document.createElement('p');
        resultsStatus.className = 'mayhem-fitment-only__status';
        resultsStatus.setAttribute('role', 'status');
        grid.before(resultsStatus);
      }
      let changeVehicle = grid.parentElement.querySelector('[data-mayhem-empty-change-vehicle]');
      if (!changeVehicle) {
        changeVehicle = document.createElement('button');
        changeVehicle.type = 'button';
        changeVehicle.className = 'button';
        changeVehicle.dataset.mayhemEmptyChangeVehicle = '';
        changeVehicle.textContent = 'Change vehicle';
        changeVehicle.hidden = true;
        changeVehicle.addEventListener('click', () => window.mayhemOpenVehiclePicker?.(changeVehicle));
        resultsStatus.after(changeVehicle);
      }
      for (const entries of collectionGrids.values()) {
        for (const [item, record] of entries) {
          if (!item.isConnected) continue;
          const shouldHide = (record.state !== 'fits' && record.state !== 'caution') ||
            item.dataset.mayhemFilterExcluded === 'true';
          if (item.hidden !== shouldHide) item.hidden = shouldHide;
        }
      }
      const matched = [...collectionGrids.values()].reduce((count, entries) =>
        count + [...entries].filter(([item, record]) =>
          item.isConnected && !item.hidden && (record.state === 'fits' || record.state === 'caution')).length, 0);
      const remainingPages = Boolean(document.querySelector('[data-mayhem-load-more]'));
      const checking = Boolean(queue.length || running || remainingPages);
      const tools = document.querySelector('[data-mayhem-collection-tools]');
      if (tools) tools.dataset.fitmentChecking = String(checking);
      const directFitOnly = tools?.dataset.directFitOnly === 'true';
      const directEmpty = document.querySelector('[data-mayhem-direct-fit-empty]');
      const hideDirectEmpty = checking || !directFitOnly || matched > 0;
      if (directEmpty && directEmpty.hidden !== hideDirectEmpty) directEmpty.hidden = hideDirectEmpty;
      const message = checking
        ? 'Finding wheels for your vehicle…'
        : pageLoadFailed
          ? 'Some wheel results could not be loaded. Refresh to retry.'
          : checkFailed
          ? 'Some fitment checks were unavailable.'
          : matched
            ? ''
            : directFitOnly
              ? 'No wheels match your current filters. Change your filters or select another vehicle.'
              : "We don’t currently have wheels available for this vehicle.";
      const showChangeVehicle = !checking && !pageLoadFailed && !checkFailed && matched === 0;
      if (changeVehicle.hidden === showChangeVehicle) changeVehicle.hidden = !showChangeVehicle;
      if (resultsStatus.textContent !== message) resultsStatus.textContent = message;
      if (resultsStatus.hidden !== !message) resultsStatus.hidden = !message;
      if (checking && matched && Date.now() - loadingSince >= 8000 &&
        document.documentElement.classList.contains('mayhem-fitment-only-loading')) {
        document.documentElement.classList.remove('mayhem-fitment-only-loading');
        document.querySelector('#ResultsList .product-grid')?.setAttribute('aria-busy', 'false');
        loadingPlaceholder?.remove();
        loadingPlaceholder = null;
      }
      if (!checking && !settleFrame && !fitmentReady) {
        settleFrame = requestAnimationFrame(() => {
          settleFrame = 0;
          if (!fitmentOnly || queue.length || running || document.querySelector('[data-mayhem-load-more]')) return;
          const badges = [...document.querySelectorAll('#ResultsList .product-grid__item [data-mayhem-card-fitment]')];
          if (badges.some(badge => !active.has(badge))) return;
          queueSort();
          if (!fitmentReady) {
            fitmentReady = true;
            window.dispatchEvent(new Event('mayhem:fitment-ready'));
          }
          document.documentElement.classList.remove('mayhem-fitment-only-loading');
          document.querySelector('#ResultsList .product-grid')?.setAttribute('aria-busy', 'false');
          loadingPlaceholder?.remove();
          loadingPlaceholder = null;
        });
      }
      const count = document.querySelector('[data-mayhem-results-count]');
      if (count) {
        if (!count.dataset.mayhemDefaultCount) count.dataset.mayhemDefaultCount = count.textContent;
        if (count.textContent !== String(matched)) count.textContent = String(matched);
      }
    };
    const loadRemainingPages = () => {
      if (!fitmentOnly || !selectedId()) return;
      const button = document.querySelector('[data-mayhem-load-more]');
      const next = button?.dataset.nextUrl;
      if (!next || button.disabled || requestedPages.has(next)) return;
      requestedPages.add(next);
      button.click();
    };
    const sortCollection = grid => {
      const entries = collectionGrids.get(grid);
      if (!entries) return;
      const id = selectedId();
      const ordered = [...entries].filter(([item]) => item.isConnected && item.parentElement === grid)
        .sort((a, b) => {
          const rank = ([item, record]) => {
            if (!id || item.hidden) return id ? 2 : 0;
            const state = item.querySelector('[data-mayhem-card-fitment]')?.dataset.state || record.state;
            return state === 'fits' ? 0 : state === 'caution' ? 1 : 2;
          };
          return rank(a) - rank(b) || a[1].index - b[1].index;
        }).map(([item]) => item);
      const current = [...grid.children].filter(item => entries.has(item));
      if (ordered.every((item, index) => item === current[index])) return;
      for (const item of ordered) grid.appendChild(item);
    };
    let sortFrame = 0;
    const queueSort = () => {
      if (sortFrame) return;
      sortFrame = requestAnimationFrame(() => {
        sortFrame = 0;
        for (const grid of collectionGrids.keys()) sortCollection(grid);
      });
    };
    window.addEventListener('mayhem:collection-filter-updated', () => {
      queueSort();
      updateResultsStatus();
    });
    const syncBrowseCard = (badge, state) => {
      const card = badge.closest('[data-mayhem-wheel-card]');
      if (!card || collectionItem(badge)) return;
      const item = card.closest('slideshow-slide') || card.closest('.resource-list__item') || card;
      const filtered = Boolean(selectedId());
      item.hidden = filtered && !['fits', 'caution'].includes(state);
      const group = card.closest('.resource-list__carousel') || card.closest('.resource-list');
      if (!group) return;
      const badges = [...group.querySelectorAll(selector)];
      const pending = filtered && badges.some(node => !node.dataset.state || node.dataset.state === 'pending');
      const matches = badges.some(node => ['fits', 'caution'].includes(node.dataset.state));
      let status = group.previousElementSibling;
      if (!status?.hasAttribute('data-mayhem-browse-status')) {
        status = document.createElement('p');
        status.dataset.mayhemBrowseStatus = '';
        status.setAttribute('role', 'status');
        group.before(status);
      }
      status.textContent = pending ? 'Finding wheels for your vehicle…' : 'No matching wheels in this selection. Browse all wheels for more options.';
      status.hidden = !filtered || (!pending && matches);
      group.hidden = filtered && !matches;
    };
    // Coalesce expensive collection counting/hiding into one update per paint frame.
    let resultsFrame = 0;
    const queueResultsStatus = () => {
      if (resultsFrame) return;
      resultsFrame = requestAnimationFrame(() => { resultsFrame = 0; updateResultsStatus(); });
    };
    const render = (badge, id, result) => {
      if (!badge.isConnected || selectedId() !== id) return;
      const { state, variant } = result;
      badge.dataset.state = state;
      syncBrowseCard(badge, state);
      badge.dataset.matchedVariants = JSON.stringify(result.matches || []);
      const entry = collectionGrids.get(collectionItem(badge)?.closest('.product-grid'))?.get(collectionItem(badge));
      if (entry) entry.state = state;
      if (fitmentOnly && entry) {
        const item = collectionItem(badge);
        item.hidden = state !== 'fits' && state !== 'caution';
        if (state === 'error') checkFailed = true;
        queueResultsStatus();
      }
      const ui = window.MayhemFitmentUI;
      if (!labels[state]) {
        ui.paint(badge, 'unknown', { scope: 'card', reasons: ui.labels.unavailable });
        return;
      }
      const link = badge.closest('[data-mayhem-wheel-card]')?.querySelector('.mayhem-wheel-card__link');
      if (link && variant?.id) {
        const url = new URL(link.dataset.defaultHref || link.href);
        url.searchParams.set('variant', String(variant.id).split('/').pop());
        link.href = url.href;
      }
      if (variant?.sku) badge.dataset.sku = variant.sku;
      ui.paint(badge, state, {
        scope: 'card', matches: result.matches || [], sku: variant?.sku, configuration: ui.configuration(variant),
        reasons: result.reasons || [],
        fitmentTypes: variant?.sku === badge.dataset.sku
          ? [...new Set([...(variant?.fitmentTypes || []), ...(variant?.applications || []).map(app => app.fitmentType).filter(Boolean)])] : [],
        sourceNotes: variant?.sku === badge.dataset.sku ? (variant?.sourceNotes || []) : [],
        mixed: state === 'fits' && (result.matches || []).some(match => match.state === 'caution')
      });

    };
    const drain = () => {
      while (running < limit && queue.length) {
        const job = queue.shift();
        if (job.generation !== generation || !job.badge.isConnected || selectedId() !== job.id) continue;
        running++;
        checkVariants(job.id, job.badge).then(result => {
          if (job.generation === generation) render(job.badge, job.id, result);
        }).finally(() => {
          running--;
          drain();
          if (!running && !queue.length) queueSort();
          queueResultsStatus();
        });
      }
    };
    const schedule = badge => {
      registerCollectionItem(badge);
      const link = badge.closest('[data-mayhem-wheel-card]')?.querySelector('.mayhem-wheel-card__link');
      if (link && !link.dataset.defaultHref) link.dataset.defaultHref = link.href;
      const id = selectedId();
      badge.hidden = true;
      badge.dataset.state = id ? 'pending' : '';
      syncBrowseCard(badge, id ? 'pending' : '');
      if (fitmentOnly) {
        const item = collectionItem(badge);
        if (item) item.hidden = Boolean(id);
      }
      if (!id || !badge.dataset.sku) {
        delete badge.dataset.state;
        delete badge.dataset.matchedVariants;
        return;
      }
      delete badge.dataset.matchedVariants;
      window.MayhemFitmentUI.paint(badge, 'pending', { scope: 'card' });
      const current = { id, badge, generation };
      queue.push(current);
      drain();
    };
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        const badge = entry.target.querySelector(selector);
        if (badge) schedule(badge);
      }
    }, { rootMargin: '260px' });
    const scan = () => {
      document.querySelectorAll(selector).forEach(badge => {
        if (active.has(badge)) return;
        active.set(badge, true);
        const card = badge.closest('[data-mayhem-wheel-card]');
        if (card) {
          if (card.closest('.product-grid') && location.pathname.startsWith('/collections/')) schedule(badge);
          else schedule(badge);
        }
      });
      loadRemainingPages();
      updateResultsStatus();
    };
    const refresh = () => {
      if (location.pathname.startsWith('/collections/') && selectedId()) fitmentOnly = true;
      generation++;
      queue.length = 0;
      if (fitmentOnly && !selectedId()) {
        fitmentOnly = false;
        document.documentElement.classList.remove('mayhem-fitment-only', 'mayhem-fitment-only-loading');
        document.querySelector('[data-mayhem-empty-change-vehicle]')?.remove();
        resultsStatus?.remove();
        resultsStatus = null;
        loadingPlaceholder?.remove();
        loadingPlaceholder = null;
        document.querySelector('#ResultsList .product-grid')?.setAttribute('aria-busy', 'false');
        for (const entries of collectionGrids.values()) {
          for (const item of entries.keys()) item.hidden = false;
        }
        const count = document.querySelector('[data-mayhem-results-count]');
        if (count) {
          const original = Number(count.dataset.mayhemDefaultCount);
          // Never show a false zero while Shopify restores the unfiltered catalog.
          count.textContent = Number.isFinite(original) && original > 0
            ? String(original) : 'Loading wheels…';
        }
        const url = new URL(location.href);
        url.searchParams.delete('fitment');
        history.replaceState(history.state, '', url.href);
      }
      if (fitmentOnly) {
        document.documentElement.classList.add('mayhem-fitment-only-loading');
        fitmentReady = false;
        loadingSince = Date.now();
        setTimeout(updateResultsStatus, 8100);
        document.querySelector('#ResultsList .product-grid')?.setAttribute('aria-busy', 'true');
        checkFailed = false;
        pageLoadFailed = false;
      }
      for (const badge of active.keys()) {
        if (!badge.isConnected) { active.delete(badge); continue; }
        badge.hidden = true;
        delete badge.dataset.state;
        if (selectedId()) window.MayhemFitmentUI.paint(badge, 'pending', { scope: 'card' });
        syncBrowseCard(badge, selectedId() ? 'pending' : '');
        const link = badge.closest('[data-mayhem-wheel-card]')?.querySelector('.mayhem-wheel-card__link');
        if (link?.dataset.defaultHref) link.href = link.dataset.defaultHref;
        const entry = collectionGrids.get(collectionItem(badge)?.closest('.product-grid'))?.get(collectionItem(badge));
        if (entry) entry.state = 'unknown';
        delete badge.dataset.matchedVariants;
        const card = badge.closest('[data-mayhem-wheel-card]');
        if (card) {
          observer.unobserve(card);
          if (entry) schedule(badge);
          else schedule(badge);
        }
      }
      queueSort();
      updateResultsStatus();
    };
    window.addEventListener('twg:vehicle-changed', refresh);
    window.addEventListener('mayhem:vehicle-changed', event => {
      eventVehicleId = /^\d+$/.test(String(event.detail?.id || '')) ? String(event.detail.id) : '';
      refresh();
    });
    window.addEventListener('mayhem:collection-page-error', () => {
      pageLoadFailed = true;
      updateResultsStatus();
    });
    window.addEventListener('storage', event => {
      if (event.key === 'mayhem:selected-vehicle-id' && eventVehicleId === undefined) refresh();
    });
    const mutation = new MutationObserver(scan);
    const boot = () => {
      if(!selectedId())document.documentElement.classList.remove('mayhem-fitment-only','mayhem-fitment-only-loading');
      if (location.pathname.startsWith('/collections/') &&
        document.querySelector('#ResultsList [data-mayhem-wheel-card]') && selectedId()) fitmentOnly = true;
      if (fitmentOnly && !selectedId()) {
        fitmentOnly = false;
        const url = new URL(location.href);
        url.searchParams.delete('fitment');
        history.replaceState(history.state, '', url.href);
      }
      if (fitmentOnly) {
        document.documentElement.classList.add('mayhem-fitment-only', 'mayhem-fitment-only-loading');
        loadingSince = Date.now();
        setTimeout(updateResultsStatus, 8100);
        const grid = document.querySelector('.product-grid');
        if (grid) {
          grid.setAttribute('aria-busy', 'true');
          resultsStatus = document.createElement('p');
          resultsStatus.className = 'mayhem-fitment-only__status';
          resultsStatus.setAttribute('role', 'status');
          resultsStatus.textContent = 'Finding wheels for your vehicle…';
          loadingPlaceholder = document.createElement('div');
          loadingPlaceholder.className = 'mayhem-fitment-only__placeholder';
          loadingPlaceholder.setAttribute('aria-hidden', 'true');
          for (let index = 0; index < 4; index++) loadingPlaceholder.append(document.createElement('span'));
          grid.before(resultsStatus);
          grid.before(loadingPlaceholder);
        }
      }
      scan();
      mutation.observe(document.body, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['data-next-url', 'disabled', 'hidden']
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mayhem-winter-badge"] && !Shopify.designMode) return;
  try {
    (() => {
  const update = () => {
    document.querySelectorAll('[data-mayhem-winter="product"]').forEach(badge => {
      let rows;
      try { rows = JSON.parse(badge.querySelector('[data-winter-variants]').textContent); } catch { badge.hidden = true; return; }
      const selected = document.querySelector('[data-mayhem-specs]')?.dataset.selectedVariantId;
      const eligible = selected ? rows.filter(row => row.id === String(selected)) : rows;
      badge.hidden = !eligible.length || !eligible.every(row => row.approved === true);
    });
  };
  document.addEventListener('mayhem:spec-selection-changed', update);
  document.addEventListener('shopify:section:load', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["resource-list-carousel"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('slideshow-component').then(() => {
    const SlideshowElement = customElements.get('slideshow-component');
    if (!SlideshowElement || SlideshowElement.prototype.__mayhemSingleStepPatched) return;

    const previousDescriptor = Object.getOwnPropertyDescriptor(SlideshowElement.prototype, 'previousIndex');
    const nextDescriptor = Object.getOwnPropertyDescriptor(SlideshowElement.prototype, 'nextIndex');

    Object.defineProperty(SlideshowElement.prototype, 'previousIndex', {
      configurable: true,
      get() {
        if (this.classList.contains('mayhem-home-carousel')) {
          return this.current - 1;
        }
        return previousDescriptor.get.call(this);
      },
    });

    Object.defineProperty(SlideshowElement.prototype, 'nextIndex', {
      configurable: true,
      get() {
        if (this.classList.contains('mayhem-home-carousel')) {
          const slides = this.slides || [];
          const visibleCount = Math.max(this.visibleSlides?.length || 1, 1);
          const maxStart = Math.max(slides.length - visibleCount, 0);

          return this.current >= maxStart ? slides.length : this.current + 1;
        }
        return nextDescriptor.get.call(this);
      },
    });

    Object.defineProperty(SlideshowElement.prototype, '__mayhemSingleStepPatched', {
      value: true,
      configurable: false,
      writable: false,
    });
  });
  } catch(e) { console.error(e); }
})();

})();
